import { ReactComponent as Card } from "assets/icons/card.svg";
import { ReactComponent as Cart } from "assets/icons/cart.svg";
import { ReactComponent as Recharge } from "assets/icons/recharge_card.svg";
import React, { FC, useCallback } from "react";
import styles from "./StartAction.module.scss";
import {
  ResolutionType,
  ScreenStore,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";

export type IconType = "CART" | "CARD" | "RECHARGE" | "NONE";

export interface IStartAction {
  onClick: () => void;
  icon: IconType;
  title: string;
  color?: string;
  subTitle?: string;
  badge?: string;
}

const StartAction: FC<IStartAction> = ({
  onClick,
  icon,
  title,
  color,
  subTitle,
  badge,
}) => {
  const [resolution] = useScreenStore((state: ScreenStore) => [
    state.resolution,
  ]);

  //TODO: Incluir outros icones
  const renderIcon = useCallback(() => {
    if (icon === "CART") {
      return (
        <Cart
          style={{
            color,
            width: resolution === ResolutionType.FULL_HD ? 95 : 50,
            height: resolution === ResolutionType.FULL_HD ? 95 : 50,
          }}
        />
      );
    }
    if (icon === "CARD") {
      return (
        <Card
          style={{
            color,
            width: resolution === ResolutionType.FULL_HD ? 95 : 50,
            height: resolution === ResolutionType.FULL_HD ? 95 : 50,
          }}
        />
      );
    }
    if (icon === "RECHARGE") {
      return (
        <Recharge
          style={{
            color,
            width: resolution === ResolutionType.FULL_HD ? 95 : 50,
            height: resolution === ResolutionType.FULL_HD ? 95 : 50,
          }}
        />
      );
    }
  }, [color, icon, resolution]);

  return (
    <div
      id={styles.StartAction}
      onClick={onClick}
      style={{ height: resolution === ResolutionType.FULL_HD ? 240 : 150 }}
    >
      {badge && (
        <span className={styles.badge}>
          <span className={styles.badgeStar}>★</span>
          {badge}
        </span>
      )}
      {renderIcon()}
      <div>
        <div
          style={{ fontSize: resolution === ResolutionType.FULL_HD ? 40 : 28 }}
        >
          {title}
        </div>
        <div
          style={{
            color: color,
            fontSize: resolution === ResolutionType.FULL_HD ? 20 : 14,
          }}
        >
          {subTitle}
        </div>
      </div>
    </div>
  );
};

export default StartAction;
